<template>
  <el-row>
    <section>
      <div class="flex flex-between">
        <div class="title-bc">
          {{ $t("m.commentDetail.finalScore") }}:{{ commentInfo.score
          }}{{ $t("m.chart.table.score") }}
        </div>
        <div v-if="cupUser" class="title-user">用户：{{ userName }}</div>
        <div class="line-right">
          <el-button
            type="primary"
            v-if="isAdd == false && this.commentInfo.suitid != 0"
            @click="reportDetailClick"
          >
            {{ $t("m.button.lookChart") }}
          </el-button>
          <el-button
            type="primary"
            v-if="isAdd == false"
            @click="dialogTableVisible = true"
            >{{ $t("m.commentDetail.scoreStandard") }}</el-button
          >
          <el-button
            type="warning"
            v-if="isAdd == false"
            @click="saveComment"
            >{{ $t("m.commentDetail.submit") }}</el-button
          >
          <el-button
            type="primary"
            v-if="isAdd == false"
            icon="el-icon-delete"
            class="active-icon"
            @click="deleteCommentBatchClick"
            >{{ $t("m.commentDetail.delete") }}</el-button
          >
          <el-button type="primary" v-if="isAdd == true" @click="changeTab1()">
            {{ $t("m.commentDetail.select") }}
          </el-button>
          <el-button type="primary" v-if="isAdd == true" @click="addComment">
            {{ $t("m.commentDetail.add") }}
          </el-button>
        </div>
      </div>
      <div class="flex flex-between input-line">
        <div class="flex input-wrap has-title">
          <span class="cus-input-title">{{ $t("m.commentDetail.name") }}</span>
          <el-input
            :placeholder="$t('m.commentDetail.name')"
            type="text"
            v-model="commentInfo.name"
          >
          </el-input>
        </div>
        <div class="flex input-wrap has-title">
          <span class="cus-input-title">{{ $t("m.commentDetail.time") }}</span>
          <el-date-picker
            v-model="commentInfo.updatetime"
            :picker-options="datePickOptions"
            type="date"
            :placeholder="$t('m.commentDetail.time')"
          >
          </el-date-picker>
        </div>
      </div>
      <div class="flex input-line">
        <div class="flex input-wrap has-title" style="width:100%;">
          <span class="cus-input-title">{{
            $t("m.commentDetail.scoreStandard")
          }}</span>
          <el-input v-model="commentInfo.notes" placeholder=""> </el-input>
        </div>
      </div>
    </section>
    <!--------杯测评分---------->
    <section>
      <div class="box-header-left flex flex-center" style="margin-top: 25px">
        <span
          class="header-span"
          :class="{ 'header-span-active': active2 == 1 }"
          @click="active2 = 1"
          >{{ $t("m.commentDetail.cupping") }} {{ totalScore }}</span
        >
        <span
          class="header-span"
          :class="{ 'header-span-active': active2 == 2 }"
          @click="active2 = 2"
          >{{ $t("m.commentDetail.defects") }} {{ xiaciscore }}</span
        >
      </div>
      <section v-if="active2 == 1">
        <div class="bc-quare">
          <div class="bc-item">
            <div class="flex flex-between">
              <span>{{ $t("m.commentDetail.dryFragrant") }}</span>
              <span class="orange-text">{{ comment.gxgs }}</span>
            </div>
            <div class="ruler-box">
              <div class="ruler-h flex">
                <div class="line-top">
                  <el-slider
                    v-model="comment.gxgs"
                    :min="6"
                    :max="10"
                    :step="0.25"
                    :show-tooltip="false"
                  ></el-slider>
                </div>
                <span v-for="i in 17" :key="i" :class="`ruler-${i}`"></span>
              </div>
              <div class="ruler-text">
                <span v-for="i in 5" :key="i"
                  ><i v-if="i != 5 && i != 1" style="opacity:0;">0</i
                  >{{ i + 5 }}</span
                >
              </div>
            </div>
            <div class="ruler-box2">
              <span>{{ $t("m.commentDetail.dry") }}</span>
              <div class="ruler-h2 flex">
                <span v-for="i in 5" :key="i" @click="comment.dry = i">
                  <i
                    class="ruler-h2-num"
                    :class="{ active: i == Math.round(comment.dry) }"
                    >{{ i }}</i
                  >
                </span>
              </div>
            </div>
            <div class="ruler-box2">
              <span>{{ $t("m.commentDetail.break") }}</span>
              <div class="ruler-h2 flex">
                <span v-for="i in 5" :key="i" @click="comment.break = i">
                  <i
                    class="ruler-h2-num"
                    :class="{ active: i == Math.round(comment.break) }"
                    >{{ i }}</i
                  >
                </span>
              </div>
            </div>
            <el-input
              v-model="comment.gxgsdesc"
              :placeholder="$t('m.commentDetail.inputDescription')"
              type="textarea"
              style="height:10px;"
              class="ruler-input"
            >
            </el-input>
          </div>
          <div class="bc-item">
            <div class="flex flex-between">
              <span>{{ $t("m.commentDetail.flavor") }}</span>
              <span class="orange-text">{{ comment.fw }}</span>
            </div>
            <div class="ruler-box">
              <div class="ruler-h flex">
                <div class="line-top">
                  <el-slider
                    v-model="comment.fw"
                    :min="6"
                    :max="10"
                    :step="0.25"
                    :show-tooltip="false"
                  ></el-slider>
                </div>
                <span v-for="i in 17" :key="i" :class="`ruler-${i}`"></span>
              </div>
              <div class="ruler-text">
                <span v-for="i in 5" :key="i"
                  ><i v-if="i != 5 && i != 1" style="opacity:0;">0</i
                  >{{ i + 5 }}</span
                >
              </div>
            </div>
            <el-input
              v-model="comment.fwdesc"
              :placeholder="$t('m.commentDetail.inputDescription')"
              type="textarea"
              class="ruler-input"
            >
            </el-input>
          </div>
          <div class="bc-item">
            <div class="flex flex-between">
              <span>{{ $t("m.commentDetail.taste") }}</span>
              <span class="orange-text">{{ comment.yw }}</span>
            </div>
            <div class="ruler-box">
              <div class="ruler-h flex">
                <div class="line-top">
                  <el-slider
                    v-model="comment.yw"
                    :min="6"
                    :max="10"
                    :step="0.25"
                    :show-tooltip="false"
                  ></el-slider>
                </div>
                <span v-for="i in 17" :key="i" :class="`ruler-${i}`"></span>
              </div>
              <div class="ruler-text">
                <span v-for="i in 5" :key="i"
                  ><i v-if="i != 5 && i != 1" style="opacity:0;">0</i
                  >{{ i + 5 }}</span
                >
              </div>
            </div>
            <el-input
              v-model="comment.ywdesc"
              :placeholder="$t('m.commentDetail.inputDescription')"
              type="textarea"
              class="ruler-input"
            >
            </el-input>
          </div>
        </div>
        <div class="bc-quare">
          <div class="bc-item">
            <div class="flex flex-between">
              <span>{{ $t("m.commentDetail.acid") }}</span>
              <span class="orange-text">{{ comment.sd }}</span>
            </div>
            <div class="ruler-box">
              <div class="ruler-h flex">
                <div class="line-top">
                  <el-slider
                    v-model="comment.sd"
                    :min="6"
                    :max="10"
                    :step="0.25"
                    :show-tooltip="false"
                  ></el-slider>
                </div>
                <span v-for="i in 17" :key="i" :class="`ruler-${i}`"></span>
              </div>
              <div class="ruler-text">
                <span v-for="i in 5" :key="i"
                  ><i v-if="i != 5 && i != 1" style="opacity:0;">0</i
                  >{{ i + 5 }}</span
                >
              </div>
            </div>
            <div class="ruler-line">{{ $t("m.commentDetail.strength") }}</div>
            <div class="ruler-box2">
              <span>{{ $t("m.commentDetail.low") }}</span>
              <div class="ruler-h2 flex">
                <span v-for="i in 4" :key="i" @click="comment.intensity = i">
                  <i
                    class="ruler-h2-num"
                    :class="{ active: i == Math.round(comment.intensity) }"
                    >{{ i }}</i
                  >
                </span>
              </div>
              <span style="margin-left:5px;">{{
                $t("m.commentDetail.high")
              }}</span>
            </div>
            <el-input
              v-model="comment.sddesc"
              :placeholder="$t('m.commentDetail.inputDescription')"
              type="textarea"
              style="height:10px;"
              class="ruler-input"
            >
            </el-input>
          </div>
          <div class="bc-item">
            <div class="flex flex-between">
              <span>{{ $t("m.commentDetail.mellow") }}</span>
              <span class="orange-text">{{ comment.chd }}</span>
            </div>
            <div class="ruler-box">
              <div class="ruler-h flex">
                <div class="line-top">
                  <el-slider
                    v-model="comment.chd"
                    :min="6"
                    :max="10"
                    :step="0.25"
                    :show-tooltip="false"
                  ></el-slider>
                </div>
                <span v-for="i in 17" :key="i" :class="`ruler-${i}`"></span>
              </div>
              <div class="ruler-text">
                <span v-for="i in 5" :key="i"
                  ><i v-if="i != 5 && i != 1" style="opacity:0;">0</i
                  >{{ i + 5 }}</span
                >
              </div>
            </div>
            <div class="ruler-line">{{ $t("m.commentDetail.degree") }}</div>
            <div class="ruler-box2">
              <span>{{ $t("m.commentDetail.thin") }}</span>
              <div class="ruler-h2 flex">
                <span v-for="i in 4" :key="i" @click="comment.level = i">
                  <i
                    class="ruler-h2-num"
                    :class="{ active: i == Math.round(comment.level) }"
                    >{{ i }}</i
                  >
                </span>
              </div>
              <span style="margin-left:5px;">{{
                $t("m.commentDetail.heavy")
              }}</span>
            </div>
            <el-input
              v-model="comment.chddesc"
              :placeholder="$t('m.commentDetail.inputDescription')"
              type="textarea"
              style="height:10px;"
              class="ruler-input"
            >
            </el-input>
          </div>
          <div class="bc-item">
            <div class="flex flex-between">
              <span>{{ $t("m.commentDetail.sweetness") }}</span>
              <span class="orange-text">{{ comment.td }}</span>
            </div>
            <div class="ruler-box">
              <div class="ruler-h flex">
                <div class="line-top">
                  <el-slider
                    v-model="comment.td"
                    :min="6"
                    :max="10"
                    :step="0.25"
                    :show-tooltip="false"
                  ></el-slider>
                </div>
                <span v-for="i in 17" :key="i" :class="`ruler-${i}`"></span>
              </div>
              <div class="ruler-text">
                <span v-for="i in 5" :key="i"
                  ><i v-if="i != 5 && i != 1" style="opacity:0;">0</i
                  >{{ i + 5 }}</span
                >
              </div>
            </div>
            <div class="ruler-box2">
              <span>{{ $t("m.commentDetail.development") }}</span>
              <div class="ruler-h2 flex">
                <span v-for="i in 4" :key="i" @click="comment.devdeg = i">
                  <i
                    class="ruler-h2-num"
                    :class="{ active: i == Math.round(comment.devdeg) }"
                    >{{ i }}</i
                  >
                </span>
              </div>
            </div>
            <div
              class="ruler-line2"
              style="margin-bottom: 6px; margin-top: 6px"
            >
              <span>{{ $t("m.commentDetail.chocolate") }}</span>
              <span>{{ $t("m.commentDetail.candy") }}</span>
              <span>{{ $t("m.commentDetail.orange") }}</span>
            </div>
            <el-input
              v-model="comment.tddesc"
              :placeholder="$t('m.commentDetail.inputDescription')"
              type="textarea"
              style="height:10px;"
              class="ruler-input"
            >
            </el-input>
          </div>
        </div>
        <div class="bc-quare">
          <div class="bc-item">
            <div class="flex flex-between">
              <span>{{ $t("m.commentDetail.balance") }}</span>
              <span class="orange-text">{{ comment.phg }}</span>
            </div>
            <div class="ruler-box">
              <div class="ruler-h flex">
                <div class="line-top">
                  <el-slider
                    v-model="comment.phg"
                    :min="6"
                    :max="10"
                    :step="0.25"
                    :show-tooltip="false"
                  ></el-slider>
                </div>
                <span v-for="i in 17" :key="i" :class="`ruler-${i}`"></span>
              </div>
              <div class="ruler-text">
                <span v-for="i in 5" :key="i"
                  ><i v-if="i != 5 && i != 1" style="opacity:0;">0</i
                  >{{ i + 5 }}</span
                >
              </div>
            </div>
            <el-input
              v-model="comment.phgdesc"
              :placeholder="$t('m.commentDetail.inputDescription')"
              type="textarea"
              class="ruler-input"
            >
            </el-input>
          </div>
          <div class="bc-item">
            <div class="flex flex-between">
              <span>{{ $t("m.commentDetail.flavorDescription") }}</span>
              <span class="orange-text">{{ comment.ztpj }}</span>
            </div>
            <div class="ruler-box">
              <div class="ruler-h flex">
                <div class="line-top">
                  <el-slider
                    v-model="comment.ztpj"
                    :min="6"
                    :max="10"
                    :step="0.25"
                    :show-tooltip="false"
                  ></el-slider>
                </div>
                <span v-for="i in 17" :key="i" :class="`ruler-${i}`"></span>
              </div>
              <div class="ruler-text">
                <span v-for="i in 5" :key="i"
                  ><i v-if="i != 5 && i != 1" style="opacity:0;">0</i
                  >{{ i + 5 }}</span
                >
              </div>
            </div>
            <el-input
              v-model="comment.ztpjdesc"
              :placeholder="$t('m.commentDetail.inputDescription')"
              type="textarea"
              class="ruler-input"
            >
            </el-input>
          </div>
          <div class="bc-item">
            <div class="flex flex-between">
              <span>{{ $t("m.commentDetail.description") }}</span>
            </div>
            <el-input
              v-model="commentInfo.level"
              :placeholder="$t('m.commentDetail.inputDescription')"
              type="textarea"
              class="ruler-input"
            >
            </el-input>
          </div>
        </div>
      </section>
      <section v-if="active2 == 2">
        <div class="bc-quare">
          <div class="bc-item">
            <div class="flex flex-between">
              <span>{{ $t("m.commentDetail.underdeveloped") }}</span>
              <span class="orange-text">{{ comment.fzwcs }}</span>
            </div>
            <div class="ruler-box">
              <div class="ruler-h flex">
                <div class="line-top">
                  <el-slider
                    v-model="comment.fzwcs"
                    :min="0"
                    :max="5"
                    :step="0.25"
                    :show-tooltip="false"
                  ></el-slider>
                </div>
                <span v-for="i in 21" :key="i" :class="`ruler-${i}`"></span>
              </div>
              <div class="ruler-text">
                <span v-for="i in 6" :key="i"
                  ><i v-if="i != 5 && i != 1" style="opacity:0;">0</i
                  >{{ i - 1 }}</span
                >
              </div>
            </div>
            <el-input
              v-model="comment.fzwcsdesc"
              :placeholder="$t('m.commentDetail.inputDescription')"
              type="textarea"
              class="ruler-input"
            >
            </el-input>
          </div>
          <div class="bc-item">
            <div class="flex flex-between">
              <span>{{ $t("m.commentDetail.overdeveloped") }}</span>
              <span class="orange-text">{{ comment.gdfz }}</span>
            </div>
            <div class="ruler-box">
              <div class="ruler-h flex">
                <div class="line-top">
                  <el-slider
                    v-model="comment.gdfz"
                    :min="0"
                    :max="5"
                    :step="0.25"
                    :show-tooltip="false"
                  ></el-slider>
                </div>
                <span v-for="i in 21" :key="i" :class="`ruler-${i}`"></span>
              </div>
              <div class="ruler-text">
                <span v-for="i in 6" :key="i"
                  ><i v-if="i != 5 && i != 1" style="opacity:0;">0</i
                  >{{ i - 1 }}</span
                >
              </div>
            </div>
            <el-input
              v-model="comment.gdfzdesc"
              :placeholder="$t('m.commentDetail.inputDescription')"
              type="textarea"
              class="ruler-input"
            >
            </el-input>
          </div>
          <div class="bc-item">
            <div class="flex flex-between">
              <span>{{ $t("m.commentDetail.baked") }}</span>
              <span class="orange-text">{{ comment.bk }}</span>
            </div>
            <div class="ruler-box">
              <div class="ruler-h flex">
                <div class="line-top">
                  <el-slider
                    v-model="comment.bk"
                    :min="0"
                    :max="5"
                    :step="0.25"
                    :show-tooltip="false"
                  ></el-slider>
                </div>
                <span v-for="i in 21" :key="i" :class="`ruler-${i}`"></span>
              </div>
              <div class="ruler-text">
                <span v-for="i in 6" :key="i"
                  ><i v-if="i != 5 && i != 1" style="opacity:0;">0</i
                  >{{ i - 1 }}</span
                >
              </div>
            </div>
            <el-input
              v-model="comment.bkdesc"
              :placeholder="$t('m.commentDetail.inputDescription')"
              type="textarea"
              class="ruler-input"
            >
            </el-input>
          </div>
        </div>
        <div class="bc-quare">
          <div class="bc-item">
            <div class="flex flex-between">
              <span>{{ $t("m.commentDetail.faced") }}</span>
              <span class="orange-text">{{ comment.bmkj }}</span>
            </div>
            <div class="ruler-box">
              <div class="ruler-h flex">
                <div class="line-top">
                  <el-slider
                    v-model="comment.bmkj"
                    :min="0"
                    :max="5"
                    :step="0.25"
                    :show-tooltip="false"
                  ></el-slider>
                </div>
                <span v-for="i in 21" :key="i" :class="`ruler-${i}`"></span>
              </div>
              <div class="ruler-text">
                <span v-for="i in 6" :key="i"
                  ><i v-if="i != 5 && i != 1" style="opacity:0;">0</i
                  >{{ i - 1 }}</span
                >
              </div>
            </div>
            <el-input
              v-model="comment.bmkjdesc"
              :placeholder="$t('m.commentDetail.inputDescription')"
              type="textarea"
              class="ruler-input"
            >
            </el-input>
          </div>
          <div class="bc-item">
            <div class="flex flex-between">
              <span>{{ $t("m.commentDetail.description") }}</span>
            </div>
            <el-input
              v-model="comment.xczms"
              :placeholder="$t('m.commentDetail.inputDescription')"
              type="textarea"
              class="ruler-input"
            >
            </el-input>
          </div>
          <div class="bc-item"></div>
        </div>
      </section>
    </section>

    <!--------曲线详情---------->
    <el-drawer
      :visible.sync="reportDetailDialog"
      size="40%"
    >
    <template slot="title">
      <span style="color: #e2e2e2;cursor: pointer" @click="reportDetailDialog = false"><i class="el-icon-arrow-left"></i>返回</span>
    </template>
      <report-chart
        @finish="reportDetailLoadingFinish"
        :report-id="selectSuitId"
        :key="reportKey"
        :not-showuser="notShowuser"
        :isNew="commentInfo.type == 'V1' ? false : true"
      ></report-chart>
    </el-drawer>
    <!--------新建时选择曲线---------->
    <el-dialog
      :title="$t('m.chart.chartSelect')"
      :visible.sync="reportListDialog"
    >
    <div class="box-header">
      <div class="flex flex-center" style="margin-bottom:10px;gap: 20px">
        <el-select v-model="searchParamKey" style="width: 150px;" placeholder="">
          <el-option
                  v-for="item in searchParamsKeyOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
          </el-option>
        </el-select>
          <div style="width: 100%">
            <el-input
              v-model="searchParamValue"
              :placeholder="$t('m.chart.table.placeholder3')"
            ></el-input>
          </div>
      </div>
      <div style="width: 100%;display: flex;gap: 10px">
        <el-select
          v-model="isSelectedUser"
          style="width: 100%"
          filterable
          remote
          reserve-keyword
          placeholder="请输入用户名并选择"
          :remote-method="getUserList"
          :loading="userLoading">
          <el-option
            v-for="item in userList"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
        <el-button @click="changeTab1()"
        type="primary"
        icon="el-icon-search"
        class="active-icon">搜索</el-button>
      </div>
    </div>
      <!--内容-->
      <div class="box-content">
        <div
        @click="checkDevice(item)"
        :class="[
      item.id == activeCurveId
        ? 'box-item box-half box-active'
        : 'box-item box-half',
    ]"
    style="flex-direction: column;"
        v-for="item in reportList"
        v-bind:key="item.id"
    >
      <div class="box-nav-title" style="color: #fff">
        {{ item.name }}
      </div>
      <div class="flex" style="align-items: center;width: 100%;gap: 5px">
        <div class="box-item-img">
          <img v-if="item.id == activeCurveId" :src="!!item.imgUrl ? item.imgUrl: 'http://oss.ihbcoffee.com/config/curveimgwhilte.png'" />
          <img v-else :src="!!item.imgUrl ? item.imgUrl: 'http://oss.ihbcoffee.com/config/curveimgblack.png'" />
          <div class="datetime">
            <el-rate
                :colors="['#FC9153', '#FC9153', '#FC9153']"
                v-model="item.score"
            ></el-rate>
          </div>
        </div>
        <div class="box-item-text">
          <!-- <div>
          <span class="text-title">{{ $t("m.chart.table.name") }}：</span
          ><span class="text-value">{{ item.name }}</span>
          </div> -->
          <div>
          <span class="text-title"
          >{{ $t("m.chart.table.duration") }}：</span
          ><span class="text-value">{{
            timeFormatter(item.duration)
            }}</span>
          </div>
          <div>
          <span class="text-title"
          >{{ $t("m.chart.table.machineName") }}：</span
          ><span class="text-value">{{
              item.deviceName == null
                  ? "无"
                  : item.deviceName
            }}</span>
          </div>
          <div>
            <span class="text-title">{{ $t("m.chart.table.date") }}：</span
            ><span class="text-value">{{
                $moment(Number(item.createtime)).format("YYYY-MM-DD")
              }}</span>
          </div>
          <div>
            <span class="text-title">{{ $t("m.chart.table.username") }}：</span
            ><span class="text-value">{{ item?.username || '--' }}</span>
            </div>
        </div>
      </div>
     
    </div>
      </div>
    </el-dialog>
    <!--------评分标准弹框---------->
    <el-dialog
      :title="$t('m.commentDetail.scoreStandard')"
      :visible.sync="dialogTableVisible"
    >
      <el-table
        :data="gridData"
        width="100%"
        :empty-text="$t('m.options.deviceSearchOptions.noData')"
      >
        <el-table-column label="Quarlity Scale">
          <el-table-column property="good" label="6.00-Good"></el-table-column>
          <el-table-column
            property="veryGood"
            label="7.00-VeryGood"
          ></el-table-column>
          <el-table-column
            property="excellent"
            label="8.00-Excellent"
          ></el-table-column>
          <el-table-column
            property="outstanding"
            label="9.00-Outstanding"
          ></el-table-column>
        </el-table-column>
      </el-table>
      <div class="text-white" style="margin-top:10px;">
        {{ $t("m.commentDetail.scoringInstructions") }}
      </div>
      <div class="bc-classfy-line">
        <div class="classfy-line-item">
          <span class="item-title">{{ $t("m.commentDetail.good") }}：</span>
          <span class="item-value">6-6.75</span>
        </div>
        <div class="classfy-line-item">
          <span class="item-title">{{ $t("m.commentDetail.veryGood") }}：</span>
          <span class="item-value">7-7.75</span>
        </div>
        <div class="classfy-line-item">
          <span class="item-title"
            >{{ $t("m.commentDetail.excellent") }}：</span
          >
          <span class="item-value">8-8.75</span>
        </div>
        <div class="classfy-line-item">
          <span class="item-title"
            >{{ $t("m.commentDetail.outstanding") }}：</span
          >
          <span class="item-value">9-9.75</span>
        </div>
      </div>
      <div class="text-white" style="margin-top:5px;">
        {{ $t("m.commentDetail.scoreDescription") }}
      </div>
      <div class="bc-classfy-line">
        <div class="classfy-line-item">
          <span class="item-title">{{ $t("m.commentDetail.noEffect") }}：</span>
          <span class="item-value">0</span>
        </div>
        <div class="classfy-line-item">
          <span class="item-title"
            >{{ $t("m.commentDetail.aLittleBit") }}：</span
          >
          <span class="item-value">1</span>
        </div>
        <div class="classfy-line-item">
          <span class="item-title">{{ $t("m.commentDetail.palpable") }}：</span>
          <span class="item-value">3</span>
        </div>
        <div class="classfy-line-item">
          <span class="item-title"
            >{{ $t("m.commentDetail.overwhelming") }}：</span
          >
          <span class="item-value">5</span>
        </div>
      </div>
    </el-dialog>
  </el-row>
</template>

<script>
import report from "@/components-online/curve/report";

export default {
  name: "commentDetailComponent",
  components: {
    "report-chart": report,
  },
  props: {
    commentId: [Number],
    edit: [Boolean],
    suitId: [Number],
    chart: [Boolean],
    isAdd: [Boolean],
    cupUser: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      active1: 1,
      activeReportId: 0,
      activeCurveId: 0,
      reportListDialog: false,
      reportList: [],
      dialogTableVisible: false,
      commentInfo: {
        name: "",
        createtime: new Date(),
        notes: "",
        score: 0,
        color: "",
        level: "",
        id: 0,
        suitid: 0,
        userid: 0,
        updatetime: new Date(),
      },
      userName: "",
      comment: {
        hbd: 0,
        gxgs: 6,
        gxgsdesc: "",
        dry: 1,
        break: 1,
        fw: 6,
        fwdesc: "",
        yw: 6,
        ywdesc: "",
        sd: 6,
        sddesc: "",
        intensity: 1,
        chd: 6,
        chddesc: "",
        level: 1,
        yzx: 0,
        yzxSub: [0, 0, 0, 0, 0],
        phg: 6,
        phgdesc: "",
        gjd: 0,
        gjdSub: [0, 0, 0, 0, 0],
        td: 6,
        devdeg: 1,
        tddesc: "",
        tdSub: [0, 0, 0, 0, 0],
        ztpj: 6,
        ztpjdesc: "",
        defects: 0,
        defectsSub: [0, 0],
        fzwcs: 0,
        fzwcsdesc: "",
        gdfz: 0,
        gdfzdesc: "",
        bk: 0,
        bkdesc: "",
        bmkj: 0,
        bmkjdesc: "",
        xczms: "",
      },
      commentAttrInstVoList: [],
      rgb: "rgb(0,0,0)",
      textColor: "rgb(255,255,255)",
      id: 0,
      totalScore: 0,
      xiaciscore: 0,
      reportDetailDialog: false,
      reportKey: 0,
      selectReportId: 0,
      selectSuitId: 0,
      detailReport: {
        name: "",
        level: "",
        type: "",
        weight: 0,
        color: "",
        user: {},
        suitVo: {
          bean: {
            name: "",
          },
          lineVoList: [], //曲线数据
          height: 0,
          weight: 0,
        },
      }, //曲线详情
      showChart: false,
      loading: undefined,
      datePickOptions: {
        disabledDate(time) {
          console.log(time);
          return time.getTime() > Date.now();
        },
      },
      active2: 1,
      valueR: 7,
      active: 1,
      role: 0,
      gridData: [
        {
          good: "6.25",
          veryGood: "7.25",
          excellent: "8.25",
          outstanding: "9.25",
        },
        {
          good: "6.50",
          veryGood: "7.50",
          excellent: "8.50",
          outstanding: "9.50",
        },
        {
          good: "6.75",
          veryGood: "7.75",
          excellent: "8.75",
          outstanding: "9.75",
        },
      ],
      notShowuser: false,
      userList: [],
      isSelectedUser: null,
      userLoading: false,
      searchParamsKeyOptions: [
        {
          value: "name",
          label: "报告名称",
        },
        {
          value: "level",
          label: "报告等级",
        },
      ],
      searchParamValue: null,
      searchParamKey: "name",
      selectedType: null
    };
  },
  watch: {
    commentId: function(val) {
      this.id = val;
      if (val != 0) {
        this.getCommentInfo();
      } else {
        this.commentInfo = {
          name: "",
          createtime: new Date(),
          notes: "",
          score: 0,
          color: "",
          level: "",
          id: 0,
          suitid: 0,
          userid: 0,
          updatetime: new Date(),
        };

        (this.comment = {
          hbd: 0,
          gxgs: 6,
          gxgsdesc: "",
          dry: 1,
          break: 1,
          fw: 6,
          fwdesc: "",
          yw: 6,
          ywdesc: "",
          sd: 6,
          sddesc: "",
          intensity: 1,
          chd: 6,
          chddesc: "",
          level: 1,
          yzx: 0,
          yzxSub: [0, 0, 0, 0, 0],
          phg: 6,
          phgdesc: "",
          gjd: 0,
          gjdSub: [0, 0, 0, 0, 0],
          td: 6,
          devdeg: 1,
          tddesc: "",
          tdSub: [0, 0, 0, 0, 0],
          ztpj: 6,
          ztpjdesc: "",
          defects: 0,
          defectsSub: [0, 0],
          fzwcs: 0,
          fzwcsdesc: "",
          gdfz: 0,
          gdfzdesc: "",
          bk: 0,
          bkdesc: "",
          bmkj: 0,
          bmkjdesc: "",
          xczms: "",
        }),
          (this.commentAttrInstVoList = []);
        this.totalScore = 0;
        this.xiaciscore = 0;
      }
    },
    suitId: function(val) {
      this.selectSuitId = val;
      // this.reportDetailClick()
    },
    chart: function(val) {
      console.info("杯测界面显示曲线");
      this.showChart = val;
    },
  },
  mounted() {
    if (localStorage.role != 1) {
      this.notShowuser = true;
    }
    this.id = this.commentId;
    this.selectSuitId = this.suitId;
    this.showChart = this.chart;
    this.role = localStorage.role;
    if (this.id == 0) {
      this.commentInfo = {
        name: "",
        createtime: new Date(),
        notes: "",
        score: 0,
        color: "",
        level: "",
        id: 0,
        suitid: 0,
        userid: 0,
        updatetime: new Date(),
      };

      (this.comment = {
        hbd: 0,
        gxgs: 6,
        gxgsdesc: "",
        dry: 1,
        break: 1,
        fw: 6,
        fwdesc: "",
        yw: 6,
        ywdesc: "",
        sd: 6,
        sddesc: "",
        intensity: 1,
        chd: 6,
        chddesc: "",
        level: 1,
        yzx: 0,
        yzxSub: [0, 0, 0, 0, 0],
        phg: 6,
        phgdesc: "",
        gjd: 0,
        gjdSub: [0, 0, 0, 0, 0],
        td: 6,
        devdeg: 1,
        tddesc: "",
        tdSub: [0, 0, 0, 0, 0],
        ztpj: 6,
        ztpjdesc: "",
        defects: 0,
        defectsSub: [0, 0],
        fzwcs: 0,
        fzwcsdesc: "",
        gdfz: 0,
        gdfzdesc: "",
        bk: 0,
        bkdesc: "",
        bmkj: 0,
        bmkjdesc: "",
        xczms: "",
      }),
        (this.commentAttrInstVoList = []);
      this.totalScore = 0;
      this.xiaciscore = 0;
    } else {
      this.getCommentInfo();
    }
  },
  methods: {
    reportDetailLoadingFinish() {
      //this.loading1.close()
    },
    reportDetailClick() {
      this.$http
        .get("/manage/report/getAReportBySuitId.do?suitId=" + this.selectSuitId)
        .then(
          function(resp) {
            this.detailReport = resp.data.data;
            this.selectReportId = this.detailReport.id;
          }.bind(this)
        )
        .catch((err) => {
          console.info(err);
        });
      this.reportDetailDialog = true;
      this.reportKey = this.selectReportId;
    },
    rgbChange(val) {
      let actVal = (val / 100) * 255;
      let textVal = 255 - actVal;
      this.rgb = "rgb(" + actVal + "," + actVal + "," + actVal + ")";
      this.textColor = "rgb(" + textVal + "," + textVal + "," + textVal + ")";
    },
    getCommentInfo() {
      this.$http
        .get("/manage/comment/getCommentVo.do", {
          params: {
            commentId: this.id,
          },
        })
        .then(
          function(resp) {
            this.userName = resp.data.data.user.name;
            this.commentInfo = resp.data.data.comment;
            this.commentInfo.updatetime = this.$moment(Number(resp.data.data.comment.updatetime)).format("YYYY/MM/DD");
            //this.hexToRgb('#'+this.commentInfo.color)
            this.commentAttrInstVoList =
              resp.data.data.commentAttrInstVoList;
            if (this.commentAttrInstVoList.length > 0) {
              for (let index in this.commentAttrInstVoList) {
                let attr = this.commentAttrInstVoList[index];
                if (attr.commentAttrInst.attrId == "64") {
                  this.comment.gxgs = parseFloat(attr.commentAttrInst.attrValue);
                  this.comment.gxgsdesc = attr.commentAttrInst.attachValue;
                  this.comment.dry = this.getAttachValue(attr.commentAttrAttachInstList, 0);
                  this.comment.break = this.getAttachValue(attr.commentAttrAttachInstList, 1);
                }

                if (attr.commentAttrInst.attrId == "67") {
                  this.comment.sd = parseFloat(attr.commentAttrInst.attrValue);
                  this.comment.sddesc = attr.commentAttrInst.attachValue;
                  this.comment.intensity = this.getAttachValue(attr.commentAttrAttachInstList, 0);
                }

                if (attr.commentAttrInst.attrId == "68") {
                  this.comment.chd = parseFloat(attr.commentAttrInst.attrValue);
                  this.comment.chddesc = attr.commentAttrInst.attachValue;
                  this.comment.level = this.getAttachValue(attr.commentAttrAttachInstList, 0);
                }
                /*if(attr.commentAttrInst.attrId==69){
                                this.comment.yzxSub=this.commentAttrInstVoList[index].commentAttrInst.attrValue.split(',')
                                let val=parseFloat(this.comment.yzxSub[0])+parseFloat(this.comment.yzxSub[1])
                                    +parseFloat(this.comment.yzxSub[2])+parseFloat(this.comment.yzxSub[3])+parseFloat(this.comment.yzxSub[4])
                                this.comment.yzx=val
                            }*/

                /*if(attr.commentAttrInst.attrId==71){
                                this.comment.gjdSub=this.commentAttrInstVoList[index].commentAttrInst.attrValue.split(',')
                                let val=parseFloat(this.comment.gjdSub[0])+parseFloat(this.comment.gjdSub[1])
                                    +parseFloat(this.comment.gjdSub[2])+parseFloat(this.comment.gjdSub[3])+parseFloat(this.comment.gjdSub[4])
                                this.comment.gjd=val
                            }*/
                if (attr.commentAttrInst.attrId == "72") {
                  this.comment.tdSub = this.commentAttrInstVoList[
                    index
                  ].commentAttrInst.attrValue.split(",");
                  this.comment.td = parseFloat(this.comment.tdSub[0]);
                  this.comment.devdeg = parseFloat(this.comment.tdSub[1]);
                  this.comment.tddesc = this.commentAttrInstVoList[
                    index
                  ].commentAttrInst.attachValue;
                }
                if (attr.commentAttrInst.attrId == "70") {
                  this.comment.phg = parseFloat(
                    this.commentAttrInstVoList[index].commentAttrInst.attrValue
                  );
                  this.comment.phgdesc = this.commentAttrInstVoList[
                    index
                  ].commentAttrInst.attachValue;
                }
                if (attr.commentAttrInst.attrId == "73") {
                  this.comment.ztpj = parseFloat(
                    this.commentAttrInstVoList[index].commentAttrInst.attrValue
                  );
                  this.comment.ztpjdesc = this.commentAttrInstVoList[
                    index
                  ].commentAttrInst.attachValue;
                }
                if (attr.commentAttrInst.attrId == "74") {
                  var defectsSub = this.commentAttrInstVoList[
                    index
                  ].commentAttrInst.attrValue.split(",");
                  this.comment.fzwcs = parseFloat(defectsSub[0]);
                  this.comment.gdfz = parseFloat(defectsSub[1]);
                  this.comment.bk = parseFloat(defectsSub[2]);
                  this.comment.bmkj = parseFloat(defectsSub[3]);

                  if (
                    this.commentAttrInstVoList[index].commentAttrInst
                      .attachValue != null
                  ) {
                    var mapDesc = this.commentAttrInstVoList[
                      index
                    ].commentAttrInst.attachValue.split(",");
                    this.comment.fzwcsdesc = mapDesc[0];
                    this.comment.gdfzdesc = mapDesc[1];
                    this.comment.bkdesc = mapDesc[2];
                    this.comment.bmkjdesc = mapDesc[3];
                    this.comment.xczms = mapDesc[4];
                  }
                  console.log(this.comment)
                  this.xiaciscore =
                    parseFloat(this.comment.fzwcs) +
                    parseFloat(this.comment.gdfz) +
                    parseFloat(this.comment.bk) +
                    parseFloat(this.comment.bmkj);
                  this.totalScore = this.commentInfo.score + this.xiaciscore;
                }
              }
            }
            this.$emit("finish");
          }.bind(this)
        ).catch()
  
    }, 
     getAttachValue(attachList, index) {
      return attachList.length > index ? parseFloat(attachList[index].attachValue) : 0;
    },
    hexToRgb(hex) {
      var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      console.info("rgb" + result);
      this.comment.hbd = parseInt((parseInt(result[1], 16) / 255) * 100);
    },
    buildCommentAttrAttach1() {
      let commentAttrList = {
        commentAttrInst: { attrId: 0, attrValue: "" },
        commentAttrAttachInstList: [],
      };
      let gxgs = JSON.parse(JSON.stringify(commentAttrList));
      console.log(gxgs)
      gxgs = {
        commentAttrInst: { attrId: 0, attrValue: "" },
        commentAttrAttachInstList: [],
      };
      gxgs.commentAttrInst.attrId = 64;
      gxgs.commentAttrInst.attrValue = this.comment.gxgs;
      gxgs.commentAttrInst.attachValue = this.comment.gxgsdesc;
      gxgs.commentAttrAttachInstList.push({
        attachValue: this.comment.dry,
        attrAttachId: 23,
        descri: "descri",
      });
      gxgs.commentAttrAttachInstList.push({
        attachValue: this.comment.break,
        attrAttachId: 24,
        descri: "descri",
      });
      this.commentAttrInstVoList.push(gxgs);

      let fw = JSON.parse(JSON.stringify(commentAttrList));
      fw = {
        commentAttrInst: { attrId: 0, attrValue: "" },
        commentAttrAttachInstList: [],
      };
      fw.commentAttrInst.attrId = 65;
      fw.commentAttrInst.attrValue = this.comment.fw;
      fw.commentAttrInst.attachValue = this.comment.fwdesc;
      this.commentAttrInstVoList.push(fw);

      let ywz = JSON.parse(JSON.stringify(commentAttrList));
      ywz = {
        commentAttrInst: { attrId: 0, attrValue: "" },
        commentAttrAttachInstList: [],
      };
      ywz.commentAttrInst.attrId = 66;
      ywz.commentAttrInst.attrValue = this.comment.yw;
      ywz.commentAttrInst.attachValue = this.comment.ywdesc;
      this.commentAttrInstVoList.push(ywz);

      let sd = JSON.parse(JSON.stringify(commentAttrList));
      sd = {
        commentAttrInst: { attrId: 0, attrValue: "" },
        commentAttrAttachInstList: [],
      };
      sd.commentAttrInst.attrId = 67;
      sd.commentAttrInst.attrValue = this.comment.sd;
      sd.commentAttrInst.attachValue = this.comment.sddesc;
      sd.commentAttrAttachInstList.push({
        attachValue: this.comment.intensity,
        attrAttachId: 25,
        descri: "descri",
      });
      this.commentAttrInstVoList.push(sd);

      let chd = JSON.parse(JSON.stringify(commentAttrList));
      chd = {
        commentAttrInst: { attrId: 0, attrValue: "" },
        commentAttrAttachInstList: [],
      };
      chd.commentAttrInst.attrId = 68;
      chd.commentAttrInst.attrValue = this.comment.chd;
      chd.commentAttrInst.attachValue = this.comment.chddesc;
      chd.commentAttrAttachInstList.push({
        attachValue: this.comment.level,
        attrAttachId: 26,
        descri: "descri",
      });
      this.commentAttrInstVoList.push(chd);

      /*let yzx=JSON.parse(JSON.stringify(commentAttrList))
                yzx={commentAttrInst:{attrId:0,attrValue:''},commentAttrAttachInstList:[]}
                yzx.commentAttrInst.attrId=69
                yzx.commentAttrInst.attrValue=this.comment.yzxSub.toString()
                this.commentAttrInstVoList.push(yzx)*/

      /*let gjd=JSON.parse(JSON.stringify(commentAttrList))
                gjd={commentAttrInst:{attrId:0,attrValue:''},commentAttrAttachInstList:[]}
                gjd.commentAttrInst.attrId=71
                gjd.commentAttrInst.attrValue=this.comment.gjdSub.toString()
                this.commentAttrInstVoList.push(gjd)*/

      let td = JSON.parse(JSON.stringify(commentAttrList));
      td = {
        commentAttrInst: { attrId: 0, attrValue: "" },
        commentAttrAttachInstList: [],
      };
      td.commentAttrInst.attrId = 72;
      td.commentAttrInst.attrValue =
        this.comment.td + "," + this.comment.devdeg;
      td.commentAttrInst.attachValue = this.comment.tddesc;
      this.commentAttrInstVoList.push(td);

      let phg = JSON.parse(JSON.stringify(commentAttrList));
      phg = {
        commentAttrInst: { attrId: 0, attrValue: "" },
        commentAttrAttachInstList: [],
      };
      phg.commentAttrInst.attrId = 70;
      phg.commentAttrInst.attrValue = this.comment.phg;
      phg.commentAttrInst.attachValue = this.comment.phgdesc;
      this.commentAttrInstVoList.push(phg);

      let ztpj = JSON.parse(JSON.stringify(commentAttrList));
      ztpj = {
        commentAttrInst: { attrId: 0, attrValue: "" },
        commentAttrAttachInstList: [],
      };
      ztpj.commentAttrInst.attrId = 73;
      ztpj.commentAttrInst.attrValue = this.comment.ztpj;
      ztpj.commentAttrInst.attachValue = this.comment.ztpjdesc;
      this.commentAttrInstVoList.push(ztpj);

      let defects = JSON.parse(JSON.stringify(commentAttrList));
      defects = {
        commentAttrInst: { attrId: 0, attrValue: "" },
        commentAttrAttachInstList: [],
      };
      defects.commentAttrInst.attrId = 74;
      defects.commentAttrInst.attrValue =
        this.comment.fzwcs +
        "," +
        this.comment.gdfz +
        "," +
        this.comment.bk +
        "," +
        this.comment.bmkj;
      defects.commentAttrInst.attachValue =
        this.comment.fzwcsdesc +
        "," +
        this.comment.gdfzdesc +
        "," +
        this.comment.bkdesc +
        "," +
        this.comment.bmkjdesc +
        "," +
        this.comment.xczms;
      this.commentAttrInstVoList.push(defects);
    },
    buildCommentAttrAttach() {
      //console.log(this.commentAttrInstVoList)
      this.commentAttrInstVoList[0].commentAttrInst.attrValue = this.comment.gxgs;
      this.commentAttrInstVoList[0].commentAttrInst.attachValue = this.comment.gxgsdesc;
        // 动态补充数组元素
        while (this.commentAttrInstVoList[0].commentAttrAttachInstList.length < 2) {
          this.commentAttrInstVoList[0].commentAttrAttachInstList.push({ attachValue: null }); // 根据实际情况初始化默认值
        }

        // 安全赋值
        this.commentAttrInstVoList[0].commentAttrAttachInstList[0].attachValue = this.comment.dry;
        this.commentAttrInstVoList[0].commentAttrAttachInstList[1].attachValue = this.comment.break;

      this.commentAttrInstVoList[1].commentAttrInst.attrValue = this.comment.fw;
      this.commentAttrInstVoList[1].commentAttrInst.attachValue = this.comment.fwdesc;

      this.commentAttrInstVoList[2].commentAttrInst.attrValue = this.comment.yw;
      this.commentAttrInstVoList[2].commentAttrInst.attachValue = this.comment.ywdesc;

      this.commentAttrInstVoList[3].commentAttrInst.attrValue = this.comment.sd;
      this.commentAttrInstVoList[3].commentAttrInst.attachValue = this.comment.sddesc;
        // 动态补充数组元素
      while (this.commentAttrInstVoList[3].commentAttrAttachInstList.length < 1) {
        this.commentAttrInstVoList[3].commentAttrAttachInstList.push({ attachValue: null }); // 根据实际情况初始化默认值
      }
      this.commentAttrInstVoList[3].commentAttrAttachInstList[0].attachValue = this.comment.intensity;
      this.commentAttrInstVoList[4].commentAttrInst.attrValue = this.comment.chd;
      this.commentAttrInstVoList[4].commentAttrInst.attachValue = this.comment.chddesc;
      while (this.commentAttrInstVoList[4].commentAttrAttachInstList.length < 1) {
        this.commentAttrInstVoList[4].commentAttrAttachInstList.push({ attachValue: null }); // 根据实际情况初始化默认值
      }
      this.commentAttrInstVoList[4].commentAttrAttachInstList[0].attachValue = this.comment.level;

      this.commentAttrInstVoList[5].commentAttrInst.attrValue =
        this.comment.td + "," + this.comment.devdeg;
      this.commentAttrInstVoList[5].commentAttrInst.attachValue = this.comment.tddesc;

      //this.commentAttrInstVoList[5].commentAttrInst.attrValue=this.comment.yzxSub.toString()

      this.commentAttrInstVoList[6].commentAttrInst.attrValue = this.comment.phg;
      this.commentAttrInstVoList[6].commentAttrInst.attachValue = this.comment.phgdesc;

      //this.commentAttrInstVoList[7].commentAttrInst.attrValue=this.comment.gjdSub.toString()

      this.commentAttrInstVoList[7].commentAttrInst.attrValue = this.comment.ztpj;
      this.commentAttrInstVoList[7].commentAttrInst.attachValue = this.comment.ztpjdesc;

      this.commentAttrInstVoList[8].commentAttrInst.attrValue =
        this.comment.fzwcs +
        "," +
        this.comment.gdfz +
        "," +
        this.comment.bk +
        "," +
        this.comment.bmkj;
      this.commentAttrInstVoList[8].commentAttrInst.attachValue =
        this.comment.fzwcsdesc +
        "," +
        this.comment.gdfzdesc +
        "," +
        this.comment.bkdesc +
        "," +
        this.comment.bmkjdesc +
        "," +
        this.comment.xczms;
    },
    countScoreAndLevel1() {
      this.totalScore =
        parseFloat(this.comment.gxgs) +
        parseFloat(this.comment.dry) +
        parseFloat(this.comment.break) +
        parseFloat(this.comment.fw) +
        parseFloat(this.comment.yw) +
        parseFloat(this.comment.sd) +
        parseFloat(this.comment.intensity) +
        parseFloat(this.comment.chd) +
        parseFloat(this.comment.level) +
        parseFloat(this.comment.td) +
        parseFloat(this.comment.devdeg) +
        parseFloat(this.comment.phg) +
        parseFloat(this.comment.ztpj);
      this.xiaciscore =
        parseFloat(this.comment.fzwcs) +
        parseFloat(this.comment.gdfz) +
        parseFloat(this.comment.bk) +
        parseFloat(this.comment.bmkj);
        console.log(this.totalScore, this.xiaciscore, this.comment)
      this.commentInfo.score = this.totalScore - this.xiaciscore;
    },
    addComment() {
      if (!this.commentInfo.name) {
        this.$message.warning(
          this.$i18n.locale === "en-US"
            ? "Please enter the cupping name"
            : "请先填写杯测名称"
        );
        return;
      }
      this.countScoreAndLevel1();
      this.buildCommentAttrAttach1();
      this.$confirm(this.$t("m.alert.submit"), this.$t("m.alert.reminder"), {
        confirmButtonText: this.$t("m.alert.confirm"),
        cancelButtonText: this.$t("m.alert.cancel"),
        type: "warning",
      })
        .then(() => {
          let url = '';
          if (this.selectedType == 'V2') {
            url = "/manage/comment/add.do?curveId=" +
            this.activeCurveId +
            "&type=" +
            this.selectedType +
            "&userid=" +
            localStorage.getItem("userid") +
            "&name=" +
            this.commentInfo.name +
            "&color=" +
            this.commentInfo.color +
            "&notes=" +
            this.commentInfo.notes +
            "&score=" +
            this.commentInfo.score +
            "&level=" +
            this.commentInfo.level +
            "&updatetime=" +
            this.$moment(this.commentInfo.updatetime).format("YYYY/MM/DD");
          } else {
            url = "/manage/comment/add.do?suitid=" +
            this.activeCurveId +
            "&userid=" +
            localStorage.getItem("userid") +
            "&name=" +
            this.commentInfo.name +
            "&color=" +
            this.commentInfo.color +
            "&notes=" +
            this.commentInfo.notes +
            "&score=" +
            this.commentInfo.score +
            "&level=" +
            this.commentInfo.level +
            "&updatetime=" +
            this.$moment(this.commentInfo.updatetime).format("YYYY/MM/DD");
          }
          
          this.$http
            .post(url, this.commentAttrInstVoList)
            .then(
              function(response) {
                if (response.data.success) {
                  this.$message.success(this.$t("m.alert.addSuccess"));
                  setTimeout(
                    function() {
                      this.$emit("hide");
                    }.bind(this),
                    1000
                  );
                  this.$router.go(0);
                } else {
                  this.$message.error(
                    this.$t("m.alert.error")
                  );
                }
              }.bind(this)
            )
            .catch();
        })
        .catch((err) => err);
    },
    saveComment() {
      this.countScoreAndLevel1();
      this.buildCommentAttrAttach();
      this.$confirm(this.$t("m.alert.submit"), this.$t("m.alert.reminder"), {
        confirmButtonText: this.$t("m.alert.confirm"),
        cancelButtonText: this.$t("m.alert.cancel"),
        type: "warning",
      })
        .then(() => {
          let url =
            "/manage/comment/update.do?id=" +
            this.id +
            "&suitid=" +
            this.commentInfo.suitid +
            "&userid=" +
            localStorage.getItem("userid") +
            "&name=" +
            this.commentInfo.name +
            "&color=" +
            this.commentInfo.color +
            "&notes=" +
            this.commentInfo.notes +
            "&score=" +
            this.commentInfo.score +
            "&level=" +
            this.commentInfo.level +
            "&updatetime=" +
            this.$moment(this.commentInfo.updatetime).format("YYYY/MM/DD");
          this.$http
            .post(url, this.commentAttrInstVoList)
            .then(
              function(response) {
                if (response.data.success) {
                  this.$message.success(this.$t("m.alert.updateSuccess"));
                  this.$router.go(0);
                } else {
                  this.$message.error(
                    this.$t("m.alert.error")
                  );
                }
              }.bind(this)
            )
            .catch((err) => err);
        })
        .catch(() => {});
    },

    deleteCommentBatchClick() {
      let ids = new Array();
      ids.push(this.id);
      if (ids.length > 0) {
        this.$confirm(
          this.$t("m.alert.deleteConfirm"),
          this.$t("m.alert.reminder"),
          {
            confirmButtonText: this.$t("m.alert.confirm"),
            cancelButtonText: this.$t("m.alert.cancel"),
            type: "warning",
          }
        ).then(() => {
          let params = new URLSearchParams();
          params.append("commentIds", ids);
          this.$http
            .post("/manage/comment/deleteComments.do", params)
            .then(
              function(resp) {
                if (resp.data.success) {
                  this.$message.success(this.$t("m.alert.deleteSuccess"));
                  this.$router.go(0);
                } else {
                  this.$message.error(
                    "" + resp.data.msg
                  );
                }
              }.bind(this)
            )
            .catch((err) => {
              console.info(err);
            });
        });
      } else {
        this.$message.error("请先选择对应的杯测");
      }
    },

    changeTab1() {
      var url = "/manage/curve/union/list/ex";
      this.$http
        .post(url, {
            pageNum: 1,
            pageSize: 50,
            userId: this.isSelectedUser
        })
        .then(
          function(resp) {
            this.reportListDialog = true;
            this.reportList = resp.data.data.list;
          }.bind(this)
        )
        .catch((err) => {
          console.info(err);
        });
    },
    checkDevice(item) {
      this.activeReportId = item.id;
      this.selectedType = item.type;
      if (item.type == 'V1') {
        this.activeCurveId = item.suitid;
      } else {
        this.activeCurveId = item.id;
      }
      this.reportListDialog = false;
    },
    clearReport() {
      this.activeReportId = 0;
      this.activeCurveId = 0;
      this.reportListDialog = false;
    },
    getUserList(query) {
      if (query !== '') {
        this.userLoading = true;
        const params = { pageNum: 1, pageSize: 50, keyword: query };
        this.$http.post('/manage/user/list', params).then(res => {
          this.userList = res.data.data.list;
          this.userLoading = false;
        }).catch(e => {
          this.userLoading = false;
        })
      } else {
        this.userList = [];
      }
   
    },
    reset() {
      this.searchParamKey = 'name';
      this.isSelectedUser = null;
      this.status = 0;
      this.getTable();
    },
    timeFormatter(value) {
      const minutes = Math.floor(value / 60);
      const secs = value % 60;
      const paddedMinutes = String(minutes).padStart(2, '0');
      const paddedSeconds = String(secs).padStart(2, '0');
      return `${paddedMinutes}:${paddedSeconds}`;
    },
  },
};
</script>

<style scoped lang="scss">
.text {
  font-size: 14px;
}

.item {
  margin-bottom: 18px;
}

.box-card {
  width: 480px;
}
::v-deep .el-drawer__wrapper {
  background: #a6a6a6a1;
}
::v-deep .el-drawer__close-btn {color: #e2e2e2}
.box-item.box-half {
  width: calc(33% - 10px);
}
.el-dialog .box-item .box-item-img + .box-item-text {
  max-width: 80%;
}
.el-dialog .box-item .box-nav-title {
  text-align: left;
  width: 100%;
}
.el-dialog .box-item-img img{
  width: 100%;
}
</style>
